import {
  ApolloClient,
  from,
  InMemoryCache,
  isReference,
  Reference,
  StoreObject,
} from "@apollo/client";

import httpLink from "./links/http-link";
import retryLink from "./links/retry-link";
import refreshTokenLink from "./links/refresh-token-link";
import tokenGateLink from "./links/token-gate-link";

const client = new ApolloClient({
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
    },
  },
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          search: {
            keyArgs: ["searchFilterList"],
          },
          // message thread lists (`find`) are paged by appending in
          // `useMessageThreadFind.fetchMore` and patched in place by websocket
          // notifications; never let the same thread be held twice (SYN-12)
          find: {
            merge: (
              _existing: readonly (Reference | StoreObject)[] | undefined,
              incoming: readonly (Reference | StoreObject)[],
            ) => {
              const seen = new Set<string>();
              return incoming.filter((item) => {
                if (!isReference(item)) return true;
                if (seen.has(item.__ref)) return false;
                seen.add(item.__ref);
                return true;
              });
            },
          },
        },
      },
    },
  }),

  link: from([tokenGateLink, refreshTokenLink, retryLink, httpLink]),
});

export default client;
